import { Grid } from '@mui/material';

import { ProductDataProps } from './props';
import { useProductData } from './hook';

import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const ProductData = (props: ProductDataProps) => {
    const { formik } = useProductData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Código"
                    name="code"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.code}
                    errors={formik.errors.code}
                    value={formik.values.code}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="description"
                    size="small"
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.description}
                    errors={formik.errors.description}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    required={!!props?.data?.id}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Aplica Escalamiento"
                    checked={Boolean(formik.values.applyEscalations)}
                    onChange={() => {
                        formik.setFieldValue(
                            'applyEscalations',
                            !formik.values.applyEscalations
                        );
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Aplica Pqr"
                    checked={Boolean(formik.values.applyPqr)}
                    onChange={() => {
                        formik.setFieldValue(
                            'applyPqr',
                            !formik.values.applyPqr
                        );
                    }}
                />
            </Grid>
        </Grid>
    );
};
